// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/ground-based-radio-aids-canada.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/ground-based-radio-aids-canada/ground-based-radio-aids-canada.js';
import g1 from '../lessons/navigation/ground-based-radio-aids-canada/ils-components.js';
import g2 from '../lessons/navigation/ground-based-radio-aids-canada/vortac-dme-tacan.js';

mount([g0, g1, g2]);
